"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antDesignVue = require("ant-design-vue");
var _lodash = require("lodash");
var _listSort = _interopRequireDefault(require("../listSort"));
const CACHED_KEY = 'TABLE_COLUMNS_OPTIONS';
var _default = exports.default = {
  name: 'TableSort',
  components: {
    AIcon: _antDesignVue.Icon,
    ListSort: _listSort.default
  },
  inject: {
    ysProviderContext: {
      default: () => ({
        api: {}
      })
    }
  },
  props: {
    cacheId: {
      type: [String, undefined],
      default: undefined
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const {
      getTableColumnConfig,
      updateTableColumnConfig
    } = this.ysProviderContext.api;
    return {
      visible: false,
      loading: false,
      sortData: [],
      getTableColumnConfig,
      updateTableColumnConfig
    };
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    async init() {
      let sortData = await this.getSortData();
      this.setColumns(sortData, !sortData || sortData.length === 0);
    },
    // 更新排序数据
    updateSortData(columns) {
      this.sortData = columns.map(column => ({
        value: column.dataIndex,
        label: column.title,
        show: column.show
      }));
    },
    // 设置列顺序
    setColumns(sortData, updateCache) {
      const columnIndexMap = sortData.reduce((acc, column, index) => {
        acc[column.value] = {
          ...column,
          index
        };
        return acc;
      }, {});
      const newColumns = (0, _lodash.cloneDeep)(this.columns);
      newColumns.sort((a, b) => columnIndexMap[a.dataIndex]?.index - columnIndexMap[b.dataIndex]?.index);
      newColumns.forEach(column => {
        column.show = columnIndexMap[column.dataIndex]?.show ?? true;
      });
      this.updateSortData(newColumns);
      if (updateCache) {
        this.updateRemoteConfig(this.sortData);
      }
      this.$emit('update:columns', newColumns);
    },
    // 获取缓存配置
    async getSortData() {
      let sortData;
      try {
        const cacheData = JSON.parse(localStorage.getItem(CACHED_KEY));
        if (cacheData[this.cacheId]) {
          sortData = cacheData[this.cacheId];
        }
      } finally {
        return sortData ?? (await this.getRemoteConfig()) ?? [];
      }
    },
    async getRemoteConfig() {
      try {
        const res = await this.getTableColumnConfig({
          code: this.cacheId
        });
        const remoteConfig = JSON.parse(res.titleValue);
        if (remoteConfig) {
          this.setCache(remoteConfig);
        }
        return remoteConfig;
      } catch {
        return undefined;
      }
    },
    // 设置缓存
    setCache(value) {
      let cacheData = {};
      try {
        cacheData = JSON.parse(localStorage.getItem(CACHED_KEY)) ?? {};
      } catch {
        cacheData = {};
      }
      cacheData[this.cacheId] = value;
      localStorage.setItem(CACHED_KEY, JSON.stringify(cacheData));
    },
    async updateRemoteConfig(value) {
      try {
        this.loading = true;
        await this.updateTableColumnConfig?.({
          code: this.cacheId,
          titleValue: JSON.stringify(value),
          type: 1
        });
      } finally {
        this.loading = false;
      }
    },
    handleConfirm() {
      this.setCache(this.sortData);
      this.setColumns(this.sortData, true);
      this.visible = false;
    }
  }
};